<template>
  <div class="min-h-screen bg-background">
    <NavigationBar />
    <main :class="['container mx-auto', isLoginPage ? '' : 'px-4 py-6']">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NavigationBar from './NavigationBar.vue'

const route = useRoute()
const isLoginPage = computed(() => route.name === 'login')
</script>
